import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAppSelector } from "../store/hook";

export default function AuthLayout() {
  const token = useAppSelector((state) => state.auth.token);

  if (token) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
